module.exports = __webpack_public_path__ + "img/banner-4.84e80928.png";